import { debounce } from 'lodash';

import { AppThunkAction, store } from '../index';
import {
  Maschine,
  Maschinenhersteller,
  BezeichnungItem,
  Produktempfehlung,
  Parameterempfehlung,
  SaegebandProdukt,
  Saegeband,
  STAB,
  VIERKANTSTAB,
  VIERKANTROHR,
  ROHR,
  TRAEGER,
  Kostenersparnis,
  WerkstoffItem,
} from './types';
import {
  paramentorBandmaterialienList,
  paramentorBandbeschichtungenList,
  paramentorFormenList,
  paramentorTraegerTypenList,
  paramentorTraegerAbmessungenList,
  paramentorVerguetungsartList,
  paramentorGefuegeartenList,
  paramentorKuehlungsartenList,
  paramentorLeistungsvorgabenList,
  paramentorProdukteList,
  paramentorProdukteAusfuehrungenList,
  paramentorMaschinenhersteller,
  paramentorMaschine,
  paramentorBandmaterialtyp,
  paramentorBandbeschichtung,
  paramentorErzeugnisForm,
  paramentorErzeugnisDurchmesser,
  paramentorErzeugnisHoehe,
  paramentorErzeugnisWandstaerke,
  paramentorErzeugnisTraegerTyp,
  paramentorErzeugnisTraegerAbmessung,
  paramentorErzeugnisWerkstoff,
  paramentorErzeugnisWerkstoffgruppe,
  paramentorVerguetungsart,
  paramentorGefuegeart,
  paramentorKuehlungsart,
  paramentorLeistungsvorgabe,
  paramentorLagenschnitt,
  paramentorAnzahlLagen,
  paramentorAnzahlProLage,
  paramentorVorhandenesSaegeband,
  paramentorVorhandenesSaegebandAusfuehrung,
  paramentorProduktempfehlung,
  paramentorParameterempfehlung,
  paramentorKostenersparnis,
  paramentorKostenProBediener,
  paramentorMaschinenkosten,
  paramentorPreisProBand,
  paramentorStandflaecheTyp,
  paramentorMaschinenProBediender,
  paramentorStandflaeche,
  paramentorBusy,
  paramentorSpannbereichError,
  paramentorProduktempfehlungFavoritesList,
  paramentorSessions,
  paramentorSessionDeleted,
  paramentorSessionAdded,
} from './actions';
import axios from 'axios';
import { uiBusy } from '../ui/actions';
import { loadUserProfile } from '../ui/thunks';
import { ParamasterUser } from '../ui/types';
import {
  trackFavItem,
  trackParamasterCalculate,
  updateMachines,
} from '../../utils/gtag';

const loaderSubscribers = new Map();
const loaders = new Map();

const loadList = async (
  dispatch: Function,
  listName: string,
  apiUrl: string,
  storeDispatch: Function,
  params?: any,
) => {
  const currentLang = store.getState().ui.lang;

  let lang: string;
  lang = currentLang || navigator.language || (navigator as any).userLanguage;

  if (store.getState().auth?.decodedAccessToken?.uid) {
    const user = await store.dispatch(
      <any>(
        loadUserProfile(
          store.getState().auth.decodedAccessToken.uid,
          true,
          false,
        )
      ),
    );
    if (user?.language && !currentLang) {
      lang = user.language;
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('lang')) {
    lang = urlParams.get('lang')!;
  }

  if (!loaders.has(listName)) {
    loaders.set(
      listName,
      new Promise(async (resolve, reject) => {
        const res = await axios.get(apiUrl, {
          params: {
            ...params,
            lang,
          },
        });
        dispatch(storeDispatch(res.data.list));
        resolve(res.data.list);
      }),
    );
  }

  try {
    loaderSubscribers.set(listName, (loaderSubscribers.get(listName) || 0) + 1);
    await loaders.get(listName);
  } finally {
    if (loaderSubscribers.get(listName) <= 1) {
      loaderSubscribers.delete(listName);
      loaders.delete(listName);
    } else {
      loaderSubscribers.set(
        listName,
        (loaderSubscribers.get(listName) || 0) - 1,
      );
    }
  }
};

const loadItem = async (
  dispatch: Function,
  itemName: string,
  apiUrl: string,
  storeDispatch: Function,
  params?: any,
) => {
  const user = await store.dispatch(
    <any>(
      loadUserProfile(store.getState().auth.decodedAccessToken.uid, true, false)
    ),
  );
  const currentLang = store.getState().ui.lang;
  const lang =
    currentLang ||
    user?.language ||
    navigator.language ||
    (navigator as any).userLanguage;

  if (!loaders.has(itemName)) {
    loaders.set(
      itemName,
      new Promise(async (resolve, reject) => {
        const res = await axios.get(apiUrl, {
          params: {
            ...params,
            lang,
          },
        });
        dispatch(storeDispatch(res.data));
        resolve(res.data);
      }),
    );
  }

  try {
    loaderSubscribers.set(itemName, (loaderSubscribers.get(itemName) || 0) + 1);
    await loaders.get(itemName);
  } finally {
    if (loaderSubscribers.get(itemName) <= 1) {
      loaderSubscribers.delete(itemName);
      loaders.delete(itemName);
    } else {
      loaderSubscribers.set(
        itemName,
        (loaderSubscribers.get(itemName) || 0) - 1,
      );
    }
  }
};

export const loadBandmaterialtypenList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (!getState().paramentor.bandmaterialienList.length || forceReload) {
      await loadList(
        dispatch,
        'bandmaterialienList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/produkte/bandmaterialtypen`,
        paramentorBandmaterialienList,
      );
    }
    return getState().paramentor.bandmaterialienList;
  };

export const loadBandbeschichtungenList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (!getState().paramentor.bandbeschichtungenList.length || forceReload) {
      await loadList(
        dispatch,
        'bandbeschichtungenList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/produkte/bandbeschichtungen`,
        paramentorBandbeschichtungenList,
      );
    }
    return getState().paramentor.bandbeschichtungenList;
  };

export const loadSessions =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (!getState().paramentor.sessions.length || forceReload) {
      await loadList(
        dispatch,
        'sessions',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/sessions`,
        paramentorSessions,
      );
    }
    return getState().paramentor.sessions;
  };

export const addSession =
  (item: any, lists: any): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(paramentorBusy(true));
    const resp = await axios.post(
      `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/sessions`,
      item,
    );
    dispatch(paramentorSessionAdded(resp.data));
    dispatch(paramentorBusy(false));
    trackFavItem(item, 'add', lists, getState().ui.user);
    return getState().paramentor.sessions;
  };

export const deleteSession =
  (item: any, lists: any): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(paramentorBusy(true));
    const resp = await axios.delete(
      `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/sessions`,
      {
        data: item,
      },
    );
    dispatch(paramentorSessionDeleted(resp.data));
    dispatch(paramentorBusy(false));
    trackFavItem(item, 'remove', lists, getState().ui.user);
    return getState().paramentor.sessions;
  };

export const loadFormenList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (!getState().paramentor.formenList.length || forceReload) {
      await loadList(
        dispatch,
        'formenList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/erzeugnis/formen`,
        paramentorFormenList,
      );
    }
    return getState().paramentor.formenList;
  };

export const loadTraegerTypenList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (!getState().paramentor.traegerTypenList.length || forceReload) {
      await loadList(
        dispatch,
        'traegerTypenList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/erzeugnis/werkstueck/traeger/typen`,
        paramentorTraegerTypenList,
      );
      dispatch(
        <any>(
          setErzeugnisTraegerTyp(getState().paramentor.traegerTypenList[0]?.id)
        ),
      );
    }
    return getState().paramentor.traegerTypenList;
  };

let lastTraegerTypId: number = 0;
export const loadTraegerAbmessungenList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (
      lastTraegerTypId !== getState().paramentor.erzeugnis.traegerTyp ||
      forceReload
    ) {
      lastTraegerTypId = Number(getState().paramentor.erzeugnis.traegerTyp);
      await loadList(
        dispatch,
        'traegerAbmessungenList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/erzeugnis/werkstueck/traeger/abmessungen/${getState().paramentor.erzeugnis.traegerTyp}`,
        paramentorTraegerAbmessungenList,
      );
      dispatch(
        <any>(
          setErzeugnisTraegerAbmessung(
            getState().paramentor.traegerAbmessungenList[0]?.id,
          )
        ),
      );
    }
    return getState().paramentor.traegerAbmessungenList;
  };

export const loadVerguetungsartenList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (!getState().paramentor.verguetungsartList.length || forceReload) {
      await loadList(
        dispatch,
        'verguetungsartList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/erzeugnis/verguetungsarten`,
        paramentorVerguetungsartList,
      );
    }
    return getState().paramentor.verguetungsartList;
  };

export const loadGefuegeartenList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (!getState().paramentor.gefuegeartenList.length || forceReload) {
      await loadList(
        dispatch,
        'gefuegeartenList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/vorgaben/gefuegearten`,
        paramentorGefuegeartenList,
      );
    }
    return getState().paramentor.gefuegeartenList;
  };

export const loadKuehlungsartenList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (!getState().paramentor.kuehlungsartenList.length || forceReload) {
      await loadList(
        dispatch,
        'kuehlungsartenList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/vorgaben/kuehlungsarten`,
        paramentorKuehlungsartenList,
      );
    }
    return getState().paramentor.kuehlungsartenList;
  };

export const loadLeistungsvorgabenList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (!getState().paramentor.leistungsvorgabenList.length || forceReload) {
      await loadList(
        dispatch,
        'leistungsvorgabenList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/vorgaben/leistungsvorgaben`,
        paramentorLeistungsvorgabenList,
      );
    }
    return getState().paramentor.leistungsvorgabenList;
  };

let lastSaegebandabmessungForProdukteList: number = 0;
export const loadProdukteList =
  (): AppThunkAction => async (dispatch, getState) => {
    if (!getState().paramentor.maschine?.saegebandabmessungId) {
      dispatch(<any>paramentorProdukteList([]));
    } else {
      if (
        lastSaegebandabmessungForProdukteList !==
        getState().paramentor.maschine?.saegebandabmessungId
      ) {
        lastSaegebandabmessungForProdukteList = Number(
          getState().paramentor.maschine?.saegebandabmessungId,
        );
        await loadList(
          dispatch,
          'produkteList',
          `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/produkte/produkte`,
          paramentorProdukteList,
          {
            saegebandabmessung:
              getState().paramentor.maschine?.saegebandabmessungId,
          },
        );
      }
    }
    return getState().paramentor.produkteList;
  };

let lastProduktIdForProdukteAusfuehrungenList: number = 0;
let lastSaegebandabmessungForProdukteAusfuehrungenList: number = 0;
export const loadProdukteAusfuehrungenList =
  (forceReload = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (
      !getState().paramentor.vorhandenesSaegeband?.id ||
      !getState().paramentor.maschine?.saegebandabmessungId
    ) {
      dispatch(<any>paramentorProdukteAusfuehrungenList([]));
    } else {
      if (
        lastProduktIdForProdukteAusfuehrungenList !==
          getState().paramentor.vorhandenesSaegeband?.id ||
        lastSaegebandabmessungForProdukteAusfuehrungenList !==
          getState().paramentor.maschine?.saegebandabmessungId ||
        forceReload
      ) {
        lastProduktIdForProdukteAusfuehrungenList = Number(
          getState().paramentor.vorhandenesSaegeband?.id,
        );
        lastSaegebandabmessungForProdukteAusfuehrungenList = Number(
          getState().paramentor.maschine?.saegebandabmessungId,
        );
        await loadList(
          dispatch,
          'produkteAusfuehrungenList',
          `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/produkte/ausfuehrungen`,
          paramentorProdukteAusfuehrungenList,
          {
            produkt: getState().paramentor.vorhandenesSaegeband?.id,
            saegebandabmessung:
              getState().paramentor.maschine?.saegebandabmessungId,
          },
        );
        dispatch(
          setVorhandenesSaegebandAusfuehrung(
            getState().paramentor.vorhandenesSaegebandAusfuehrungenList[0],
          ),
        );
      }
    }
    return getState().paramentor.vorhandenesSaegebandAusfuehrungenList;
  };

export const loadProduktempfehlungFavoritesList =
  (forceReload: boolean = false): AppThunkAction =>
  async (dispatch, getState) => {
    if (
      !getState().paramentor.produktempfehlungFavoritesList?.length ||
      forceReload
    ) {
      await loadList(
        dispatch,
        'produktempfehlungFavoritesList',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/favorites/${getState().auth.decodedAccessToken.uid}`,
        paramentorProduktempfehlungFavoritesList,
      );
    }
    return getState().paramentor.produktempfehlungFavoritesList;
  };

export const loadMaschinenhersteller =
  (id?: number): AppThunkAction =>
  async (dispatch, getState) => {
    if (id) {
      await loadItem(
        dispatch,
        'maschinenherstellerItem',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/maschinenhersteller/${id}`,
        setMaschinenhersteller,
      );
    } else {
      dispatch(setMaschinenhersteller());
    }
    return getState().paramentor.maschinenhersteller;
  };

export const loadMaschine =
  (id?: number): AppThunkAction =>
  async (dispatch, getState) => {
    if (id) {
      await loadItem(
        dispatch,
        'maschineItem',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/maschinen/${id}`,
        setMaschine,
      );
    } else {
      dispatch(setMaschine());
    }
    return getState().paramentor.maschine;
  };

export const setMaschinenhersteller =
  (maschinenhersteller?: Maschinenhersteller): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorMaschinenhersteller(maschinenhersteller));
    dispatch(<any>verifyMaschine());
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.maschinenhersteller;
  };

export const setMaschine =
  (maschine?: Maschine): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorMaschine(maschine));
    if (maschine) {
      await dispatch(loadProdukteList());
    } else {
      dispatch(paramentorProdukteList([]));
    }
    dispatch(<any>verifyMaschinenhersteller());
    dispatch(<any>loadProdukteAusfuehrungenList());
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.maschine;
  };

export const verifyMaschine =
  (): AppThunkAction => async (dispatch, getState) => {
    if (
      getState().paramentor.maschinenhersteller?.id !==
      getState().paramentor.maschine?.maschinenherstellerId
    ) {
      dispatch(paramentorMaschine());
    }

    return getState().paramentor.maschine;
  };

export const verifyMaschinenhersteller =
  (): AppThunkAction => async (dispatch, getState) => {
    if (
      getState().paramentor.maschinenhersteller?.id !==
      getState().paramentor.maschine?.maschinenherstellerId
    ) {
      if (getState().paramentor.maschine) {
        dispatch(
          paramentorMaschinenhersteller({
            id: (<Maschine>getState().paramentor.maschine)
              .maschinenherstellerId,
            name: (<Maschine>getState().paramentor.maschine)
              .maschinenhersteller,
          }),
        );
      } else {
        dispatch(paramentorMaschinenhersteller());
      }
    }

    return getState().paramentor.maschinenhersteller;
  };

export const setErzeugnisForm =
  (form: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorErzeugnisForm(form));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.erzeugnis.form;
  };

export const setErzeugnisDurchmesser =
  (durchmesser?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorErzeugnisDurchmesser(durchmesser));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.erzeugnis.durchmesser;
  };

export const setErzeugnisHoehe =
  (hoehe?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorErzeugnisHoehe(hoehe));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.erzeugnis.hoehe;
  };

export const setErzeugnisWandstaerke =
  (wandstaerke?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorErzeugnisWandstaerke(wandstaerke));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.erzeugnis.wandstaerke;
  };

export const setErzeugnisTraegerTyp =
  (traegerTyp?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorErzeugnisTraegerTyp(traegerTyp));
    await dispatch(<any>loadTraegerAbmessungenList());
    return getState().paramentor.erzeugnis.traegerTyp;
  };

export const setErzeugnisTraegerAbmessung =
  (traegerAbmessung?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorErzeugnisTraegerAbmessung(traegerAbmessung));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.erzeugnis.traegerAbmessung;
  };

export const loadErzeugnisWerkstoff =
  (id?: number): AppThunkAction =>
  async (dispatch, getState) => {
    if (id) {
      await loadItem(
        dispatch,
        'werkstoffItem',
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/erzeugnis/werkstoffe/${id}`,
        setErzeugnisWerkstoff,
      );
    } else {
      dispatch(setErzeugnisWerkstoff());
    }
    return getState().paramentor.erzeugnis.werkstoff;
  };

export const setErzeugnisWerkstoff =
  (werkstoff?: WerkstoffItem): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorErzeugnisWerkstoff(werkstoff));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.erzeugnis.werkstoff;
  };

export const setErzeugnisWerkstoffgruppe =
  (werkstoffgruppe?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorErzeugnisWerkstoffgruppe(werkstoffgruppe));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.erzeugnis.werkstoffgruppe;
  };

export const setBandmaterialtyp =
  (id: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorBandmaterialtyp(id));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.bandmaterialtyp;
  };

export const setBandbeschichtung =
  (id: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorBandbeschichtung(id));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.bandbeschichtung;
  };

export const setVerguetungsart =
  (id: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorVerguetungsart(id));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.verguetungsart;
  };

export const setGefuegeart =
  (id: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorGefuegeart(id));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.gefuegeart;
  };

export const setKuehlungsart =
  (id: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorKuehlungsart(id));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.kuehlungsart;
  };

export const setLeistungsvorgabe =
  (id: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorLeistungsvorgabe(id));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.leistungsvorgabe;
  };

export const setLagenschnitt =
  (on: boolean): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorLagenschnitt(on));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.lagenschnitt;
  };

export const setAnzahlLagen =
  (anzahl: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorAnzahlLagen(anzahl));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.anzahlLagen;
  };

export const setAnzahlProLage =
  (anzahl: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorAnzahlProLage(anzahl));
    dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    return getState().paramentor.anzahlProLage;
  };

export const setVorhandenesSaegeband =
  (produkt?: SaegebandProdukt): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorVorhandenesSaegeband(produkt));
    dispatch(<any>loadProdukteAusfuehrungenList());
    return getState().paramentor.vorhandenesSaegeband;
  };

export const setVorhandenesSaegebandAusfuehrung =
  (vorhandenesSaegeband?: Saegeband): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(
      <any>paramentorVorhandenesSaegebandAusfuehrung(vorhandenesSaegeband),
    );
    if (vorhandenesSaegeband) {
      dispatch(<any>updateProduktempfehlungAndParameterempfehlung());
    }
    return getState().paramentor.vorhandenesSaegebandAusfuehrung;
  };

let lastProduktempfehlungAndParameterempfehlungHash: any = null;
const updateProduktempfehlungAndParameterempfehlungDebounced = debounce(
  async (dispatch, getState, forceReload = false) => {
    try {
      dispatch(paramentorBusy(true));
      dispatch(paramentorSpannbereichError(false));
      let hasErrors: string | false = false;

      const params: any = {
        empfehlungen: 1,
        bandmaterial: getState().paramentor.bandmaterialtyp,
        beschichtung: getState().paramentor.bandbeschichtung,
        werkstueckForm: getState().paramentor.erzeugnis.form,
        gefuege: getState().paramentor.gefuegeart,
        kuehlungsart: getState().paramentor.kuehlungsart,
        leistungsvorgabe: getState().paramentor.leistungsvorgabe,
      };

      if (getState().paramentor.vorhandenesSaegebandAusfuehrung?.wikusFamilie) {
        params.wikusfamilie =
          getState().paramentor.vorhandenesSaegebandAusfuehrung?.wikusFamilie;
      }

      params.anzahlLagen = getState().paramentor.lagenschnitt
        ? getState().paramentor.anzahlLagen
        : 1;
      params.anzahlProLage = getState().paramentor.lagenschnitt
        ? getState().paramentor.anzahlProLage
        : 1;

      if (!getState().ui.user?.einheitensystem) {
        hasErrors =
          hasErrors || 'Incomplete Parameters, missing einheitensystem';
      }
      params.einheitensystem = getState().ui.user?.einheitensystem;

      if (!getState().paramentor.maschine?.id) {
        hasErrors = 'Incomplete Parameters, missing maschine';
      }
      params.maschine = getState().paramentor.maschine?.id;

      let werkstueckBreite: number = 0;
      let werkstueckHoehe: number = 0;
      switch (getState().paramentor.erzeugnis.form) {
        case STAB:
          if (
            !getState().paramentor.erzeugnis.durchmesser ||
            !getState().paramentor.erzeugnis.werkstoff
          ) {
            hasErrors = hasErrors || 'Incomplete Parameters, missing stab';
          }
          params.werkstueckDurchmesser =
            getState().paramentor.erzeugnis.durchmesser;
          werkstueckBreite = params.werkstueckDurchmesser;
          werkstueckHoehe = params.werkstueckDurchmesser;
          params.werkstoff = getState().paramentor.erzeugnis.werkstoff?.id;
          if (!getState().paramentor.verguetungsart) {
            hasErrors =
              hasErrors || 'Incomplete Parameters, missing verguetungsart stab';
          }
          params.verguetungsart = getState().paramentor.verguetungsart;
          break;

        case VIERKANTSTAB:
          if (
            !getState().paramentor.erzeugnis.durchmesser ||
            !getState().paramentor.erzeugnis.hoehe ||
            !getState().paramentor.erzeugnis.werkstoff
          ) {
            hasErrors =
              hasErrors || 'Incomplete Parameters, missing vierkantstab';
          }
          params.werkstueckDurchmesser =
            getState().paramentor.erzeugnis.durchmesser;
          params.werkstueckHoehe = getState().paramentor.erzeugnis.hoehe;
          werkstueckBreite = params.werkstueckDurchmesser;
          werkstueckHoehe = params.werkstueckHoehe;
          params.werkstoff = getState().paramentor.erzeugnis.werkstoff?.id;
          if (!getState().paramentor.verguetungsart) {
            hasErrors =
              hasErrors ||
              'Incomplete Parameters, missing verguetungsart vierkantstab';
          }
          params.verguetungsart = getState().paramentor.verguetungsart;
          break;

        case VIERKANTROHR:
          if (
            !getState().paramentor.erzeugnis.durchmesser ||
            !getState().paramentor.erzeugnis.hoehe ||
            !getState().paramentor.erzeugnis.wandstaerke ||
            !getState().paramentor.erzeugnis.werkstoff
          ) {
            hasErrors =
              hasErrors || 'Incomplete Parameters, missing vierkantrohr';
          }
          params.werkstueckDurchmesser =
            getState().paramentor.erzeugnis.durchmesser;
          params.werkstueckHoehe = getState().paramentor.erzeugnis.hoehe;
          params.werkstueckWandstaerke =
            getState().paramentor.erzeugnis.wandstaerke;
          werkstueckBreite = params.werkstueckDurchmesser;
          werkstueckHoehe = params.werkstueckHoehe;
          params.werkstoff = getState().paramentor.erzeugnis.werkstoff?.id;
          if (!getState().paramentor.verguetungsart) {
            hasErrors =
              hasErrors ||
              'Incomplete Parameters, missing verguetungsart vierkantrohr';
          }
          params.verguetungsart = getState().paramentor.verguetungsart;
          break;

        case ROHR:
          if (
            !getState().paramentor.erzeugnis.durchmesser ||
            !getState().paramentor.erzeugnis.wandstaerke ||
            !getState().paramentor.erzeugnis.werkstoff
          ) {
            hasErrors = hasErrors || 'Incomplete Parameters, missing rohr';
          }
          params.werkstueckDurchmesser =
            getState().paramentor.erzeugnis.durchmesser;
          params.werkstueckWandstaerke =
            getState().paramentor.erzeugnis.wandstaerke;
          werkstueckBreite = params.werkstueckDurchmesser;
          werkstueckHoehe = params.werkstueckDurchmesser;
          params.werkstoff = getState().paramentor.erzeugnis.werkstoff?.id;
          if (!getState().paramentor.verguetungsart) {
            hasErrors =
              hasErrors || 'Incomplete Parameters, missing verguetungsart rohr';
          }
          params.verguetungsart = getState().paramentor.verguetungsart;
          break;

        case TRAEGER:
          if (
            !getState().paramentor.erzeugnis.traegerAbmessung ||
            !getState().paramentor.erzeugnis.traegerAbmessung
          ) {
            hasErrors = hasErrors || 'Incomplete Parameters, missing traeger';
          }
          params.werkstueckTraegerAbmessung =
            getState().paramentor.erzeugnis.traegerAbmessung;
          const traegerAbmessung =
            getState().paramentor.traegerAbmessungenList.find(
              (el: any) => el.id === params.werkstueckTraegerAbmessung,
            );
          werkstueckBreite = traegerAbmessung?.breite;
          werkstueckHoehe = traegerAbmessung?.hoehe;
          params.anzahlLagen = 1;
          params.anzahlProLage = 1;
          break;
      }

      if (getState().paramentor.erzeugnis.werkstoff?.verguetungsart === 1) {
        params.verguetungsart = 1;
      }

      if (
        params.einheitensystem === 2 &&
        getState().paramentor.erzeugnis.form !== TRAEGER
      ) {
        if (params.werkstueckDurchmesser) {
          params.werkstueckDurchmesser *= 25.4;
        }
        if (params.werkstueckHoehe) {
          params.werkstueckHoehe *= 25.4;
        }
        if (params.werkstueckWandstaerke) {
          params.werkstueckWandstaerke *= 25.4;
        }
        werkstueckBreite *= 25.4;
        werkstueckHoehe *= 25.4;
      }

      if (getState().paramentor.maschine) {
        if (
          werkstueckBreite > 0 &&
          getState().paramentor.maschine.spannbareBreite <
            Number(werkstueckBreite) * params.anzahlProLage
        ) {
          dispatch(paramentorSpannbereichError(true));
          hasErrors = hasErrors || 'Clamping range failed';
        }
        if (
          werkstueckHoehe > 0 &&
          getState().paramentor.maschine.spannbareHoehe <
            Number(werkstueckHoehe) * params.anzahlLagen
        ) {
          dispatch(paramentorSpannbereichError(true));
          hasErrors = hasErrors || 'Clamping range failed';
        }
      }

      if (hasErrors !== false) {
        throw new Error(String(hasErrors));
      }

      const newProduktempfehlungAndParameterempfehlungHash: any =
        JSON.stringify(params);

      if (
        lastProduktempfehlungAndParameterempfehlungHash ===
          newProduktempfehlungAndParameterempfehlungHash &&
        !forceReload
      ) {
        return;
      }
      lastProduktempfehlungAndParameterempfehlungHash =
        newProduktempfehlungAndParameterempfehlungHash;

      const data = await axios.get(
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/produkte/produktempfehlung`,
        {
          params,
        },
      );

      trackParamasterCalculate(getState().paramentor, getState().ui.user);

      const isImperial = params.einheitensystem === 2;
      data.data?.empfehlungen?.L1
        ? dispatch(
            <any>paramentorProduktempfehlung(1, {
              ...data.data?.empfehlungen?.L1,
              saegebandabmessung: isImperial
                ? data.data?.abmessungenImperial
                : data.data?.abmessungenMetric,
            }),
          )
        : dispatch(<any>paramentorProduktempfehlung(1));
      data.data?.empfehlungen?.L2
        ? dispatch(
            <any>paramentorProduktempfehlung(2, {
              ...data.data?.empfehlungen?.L2,
              saegebandabmessung: isImperial
                ? data.data?.abmessungenImperial
                : data.data?.abmessungenMetric,
            }),
          )
        : dispatch(<any>paramentorProduktempfehlung(2));
      data.data?.empfehlungen?.L3
        ? dispatch(
            <any>paramentorProduktempfehlung(3, {
              ...data.data?.empfehlungen?.L3,
              saegebandabmessung: isImperial
                ? data.data?.abmessungenImperial
                : data.data?.abmessungenMetric,
            }),
          )
        : dispatch(<any>paramentorProduktempfehlung(3));

      dispatch(<any>paramentorParameterempfehlung(1, data.data?.parameter?.L1));
      dispatch(<any>paramentorParameterempfehlung(2, data.data?.parameter?.L2));
      dispatch(<any>paramentorParameterempfehlung(3, data.data?.parameter?.L3));
      dispatch(<any>paramentorParameterempfehlung(4, data.data?.parameter?.W));
    } catch (e) {
      dispatch(<any>paramentorProduktempfehlung(1));
      dispatch(<any>paramentorProduktempfehlung(2));
      dispatch(<any>paramentorProduktempfehlung(3));

      dispatch(<any>paramentorParameterempfehlung(1));
      dispatch(<any>paramentorParameterempfehlung(2));
      dispatch(<any>paramentorParameterempfehlung(3));
      dispatch(<any>paramentorParameterempfehlung(4));
    } finally {
      dispatch(paramentorBusy(false));
    }
  },
  100,
);

export const updateProduktempfehlungAndParameterempfehlung =
  (forceReload = false): AppThunkAction =>
  async (dispatch, getState) => {
    return updateProduktempfehlungAndParameterempfehlungDebounced(
      dispatch,
      getState,
      forceReload,
    );
  };

export const setProduktempfehlung =
  (level: number, produktempfehlung?: Produktempfehlung): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorProduktempfehlung(level, produktempfehlung));
  };

export const setParameterempfehlung =
  (level: number, parameterempfehlung?: Parameterempfehlung): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorParameterempfehlung(level, parameterempfehlung));
  };

export const setMaschinenkosten =
  (maschinenkosten?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorMaschinenkosten(maschinenkosten));
    if (maschinenkosten) {
      dispatch(<any>updateKostenersparnis());
    }
    return getState().paramentor.vorhandenesSaegebandAusfuehrung;
  };

export const setKostenProBediener =
  (kostenProBediener?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorKostenProBediener(kostenProBediener));
    if (kostenProBediener) {
      dispatch(<any>updateKostenersparnis());
    }
    return getState().paramentor.vorhandenesSaegebandAusfuehrung;
  };

export const setPreisProBand =
  (level: number, preisProBand?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorPreisProBand(level, preisProBand));
    if (preisProBand) {
      dispatch(<any>updateKostenersparnis());
    }
    switch (level) {
      case 1:
        return getState().paramentor.preisProBandLevel1;
      case 2:
        return getState().paramentor.preisProBandLevel2;
      case 3:
        return getState().paramentor.preisProBandLevel3;
      case 4:
        return getState().paramentor.preisProBandVorhandenesSaegeband;
      default:
        throw new Error('Invalid level: ' + level);
    }
  };

export const setStandflaeche =
  (level: number, standflaeche?: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorStandflaeche(level, standflaeche));
    if (standflaeche) {
      dispatch(<any>updateKostenersparnis());
    }
    switch (level) {
      case 1:
        return getState().paramentor.standflaecheLevel1;
      case 2:
        return getState().paramentor.standflaecheLevel2;
      case 3:
        return getState().paramentor.standflaecheLevel3;
      case 4:
        return getState().paramentor.standflaecheVorhandenesSaegeband;
      default:
        throw new Error('Invalid level: ' + level);
    }
  };

export const setStandflaecheTyp =
  (level: number, standflaecheTyp: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorStandflaecheTyp(level, standflaecheTyp));
    if (standflaecheTyp) {
      dispatch(<any>updateKostenersparnis());
    }
    switch (level) {
      case 1:
        return getState().paramentor.standflaecheTypLevel1;
      case 2:
        return getState().paramentor.standflaecheTypLevel2;
      case 3:
        return getState().paramentor.standflaecheTypLevel3;
      case 4:
        return getState().paramentor.standflaecheTypVorhandenesSaegeband;
      default:
        throw new Error('Invalid level: ' + level);
    }
  };

export const setMaschinenProBediender =
  (level: number, maschinenProBediender: number): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(
      <any>paramentorMaschinenProBediender(level, maschinenProBediender),
    );
    if (maschinenProBediender) {
      dispatch(<any>updateKostenersparnis());
    }
    switch (level) {
      case 1:
        return getState().paramentor.maschinenProBedienderLevel1;
      case 2:
        return getState().paramentor.maschinenProBedienderLevel2;
      case 3:
        return getState().paramentor.maschinenProBedienderLevel3;
      case 4:
        return getState().paramentor.maschinenProBedienderVorhandenesSaegeband;
      default:
        throw new Error('Invalid level: ' + level);
    }
  };

let lastKostenersparnisHash: any = null;
const updateKostenersparnisDebounced = debounce(async (dispatch, getState) => {
  try {
    dispatch(paramentorBusy(true));

    if (!getState().paramentor.maschinenkosten) {
      throw new Error('Incomplete Parameters');
    }

    if (!getState().paramentor.kostenProBediener) {
      throw new Error('Incomplete Parameters');
    }

    if (!getState().ui.user?.einheitensystem) {
      throw new Error('Incomplete Parameters');
    }

    const params: any = {
      maschinenkosten: getState().paramentor.maschinenkosten,
      kostenProBediener: getState().paramentor.kostenProBediener,
      einheitensystem: getState().ui.user.einheitensystem,
    };

    [1, 2, 3, 4].map((level: number) => {
      try {
        switch (level) {
          case 1:
            if (
              !getState().paramentor.preisProBandLevel1 ||
              !getState().paramentor.standflaecheLevel1 ||
              !getState().paramentor.standflaecheTypLevel1 ||
              !getState().paramentor.maschinenProBedienderLevel1 ||
              !getState().paramentor.parameterempfehlungLevel1
                ?.schnittflaeche ||
              !getState().paramentor.parameterempfehlungLevel1?.schnittzeitReal
            ) {
              throw new Error('Incomplete Parameters');
            }
            params.preisProBandLevel1 =
              getState().paramentor.preisProBandLevel1;
            params.standflaecheLevel1 =
              getState().paramentor.standflaecheLevel1;
            params.standflaecheTypLevel1 =
              getState().paramentor.standflaecheTypLevel1;
            if (
              params.standflaecheTypLevel1 === 2 &&
              params.einheitensystem === 2
            ) {
              params.standflaecheLevel1 = params.standflaecheLevel1 / 1550;
            }
            params.maschinenProBedienderLevel1 =
              getState().paramentor.maschinenProBedienderLevel1;
            params.schnittflaecheLevel1 =
              getState().paramentor.parameterempfehlungLevel1.schnittflaeche;
            params.schnittzeitLevel1 =
              getState().paramentor.parameterempfehlungLevel1.schnittzeitReal;
            break;
          case 2:
            if (
              !getState().paramentor.preisProBandLevel2 ||
              !getState().paramentor.standflaecheLevel2 ||
              !getState().paramentor.standflaecheTypLevel2 ||
              !getState().paramentor.maschinenProBedienderLevel2 ||
              !getState().paramentor.parameterempfehlungLevel2
                ?.schnittflaeche ||
              !getState().paramentor.parameterempfehlungLevel2?.schnittzeitReal
            ) {
              throw new Error('Incomplete Parameters');
            }
            params.preisProBandLevel2 =
              getState().paramentor.preisProBandLevel2;
            params.standflaecheLevel2 =
              getState().paramentor.standflaecheLevel2;
            params.standflaecheTypLevel2 =
              getState().paramentor.standflaecheTypLevel2;
            if (
              params.standflaecheTypLevel2 === 2 &&
              params.einheitensystem === 2
            ) {
              params.standflaecheLevel2 = params.standflaecheLevel2 / 1550;
            }
            params.maschinenProBedienderLevel2 =
              getState().paramentor.maschinenProBedienderLevel2;
            params.schnittflaecheLevel2 =
              getState().paramentor.parameterempfehlungLevel2.schnittflaeche;
            params.schnittzeitLevel2 =
              getState().paramentor.parameterempfehlungLevel2.schnittzeitReal;
            break;
          case 3:
            if (
              !getState().paramentor.preisProBandLevel3 ||
              !getState().paramentor.standflaecheLevel3 ||
              !getState().paramentor.standflaecheTypLevel3 ||
              !getState().paramentor.maschinenProBedienderLevel3 ||
              !getState().paramentor.parameterempfehlungLevel3
                ?.schnittflaeche ||
              !getState().paramentor.parameterempfehlungLevel3?.schnittzeitReal
            ) {
              throw new Error('Incomplete Parameters');
            }
            params.preisProBandLevel3 =
              getState().paramentor.preisProBandLevel3;
            params.standflaecheLevel3 =
              getState().paramentor.standflaecheLevel3;
            params.standflaecheTypLevel3 =
              getState().paramentor.standflaecheTypLevel3;
            if (
              params.standflaecheTypLevel3 === 2 &&
              params.einheitensystem === 2
            ) {
              params.standflaecheLevel3 = params.standflaecheLevel3 / 1550;
            }
            params.maschinenProBedienderLevel3 =
              getState().paramentor.maschinenProBedienderLevel3;
            params.schnittflaecheLevel3 =
              getState().paramentor.parameterempfehlungLevel3.schnittflaeche;
            params.schnittzeitLevel3 =
              getState().paramentor.parameterempfehlungLevel3.schnittzeitReal;
            break;
          case 4:
            if (
              !getState().paramentor.preisProBandVorhandenesSaegeband ||
              !getState().paramentor.standflaecheVorhandenesSaegeband ||
              !getState().paramentor.standflaecheTypVorhandenesSaegeband ||
              !getState().paramentor
                .maschinenProBedienderVorhandenesSaegeband ||
              !getState().paramentor.parameterempfehlungVorhandenesSaegeband
                ?.schnittflaeche ||
              !getState().paramentor.parameterempfehlungVorhandenesSaegeband
                ?.schnittzeitReal
            ) {
              throw new Error('Incomplete Parameters');
            }
            params.preisProBandVorhandenesSaegeband =
              getState().paramentor.preisProBandVorhandenesSaegeband;
            params.standflaecheVorhandenesSaegeband =
              getState().paramentor.standflaecheVorhandenesSaegeband;
            params.standflaecheTypVorhandenesSaegeband =
              getState().paramentor.standflaecheTypVorhandenesSaegeband;
            if (
              params.standflaecheTypVorhandenesSaegeband === 2 &&
              params.einheitensystem === 2
            ) {
              params.standflaecheVorhandenesSaegeband =
                params.standflaecheVorhandenesSaegeband / 1550;
            }
            params.maschinenProBedienderVorhandenesSaegeband =
              getState().paramentor.maschinenProBedienderVorhandenesSaegeband;
            params.schnittflaecheVorhandenesSaegeband =
              getState().paramentor.parameterempfehlungVorhandenesSaegeband.schnittflaeche;
            params.schnittzeitVorhandenesSaegeband =
              getState().paramentor.parameterempfehlungVorhandenesSaegeband.schnittzeitReal;
            break;
        }
      } catch (e) {
        dispatch(<any>paramentorKostenersparnis(level));
      }
    });

    const newKostenersparnisHash: any = JSON.stringify(params);

    if (lastKostenersparnisHash === newKostenersparnisHash) {
      return;
    }
    lastKostenersparnisHash = newKostenersparnisHash;

    const data = await axios.get(
      `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/produkte/kostenersparnis`,
      {
        params,
      },
    );

    dispatch(
      <any>paramentorKostenersparnis(1, data.data?.kostenersparnisLevel1),
    );
    dispatch(
      <any>paramentorKostenersparnis(2, data.data?.kostenersparnisLevel2),
    );
    dispatch(
      <any>paramentorKostenersparnis(3, data.data?.kostenersparnisLevel3),
    );
    dispatch(
      <any>(
        paramentorKostenersparnis(
          4,
          data.data?.kostenersparnisVorhandenesSaegeband,
        )
      ),
    );
  } catch (e) {
    dispatch(<any>paramentorKostenersparnis(1));
    dispatch(<any>paramentorKostenersparnis(2));
    dispatch(<any>paramentorKostenersparnis(3));
    dispatch(<any>paramentorKostenersparnis(4));
  } finally {
    dispatch(paramentorBusy(false));
  }
}, 100);

export const updateKostenersparnis =
  (): AppThunkAction => async (dispatch, getState) => {
    return updateKostenersparnisDebounced(dispatch, getState);
  };

export const setKostenersparnis =
  (level: number, kostenersparnis?: Kostenersparnis): AppThunkAction =>
  async (dispatch, getState) => {
    dispatch(<any>paramentorKostenersparnis(level, kostenersparnis));
  };

export const loadDownloadableDatenList =
  (): AppThunkAction => async (dispatch, getState) => {
    try {
      dispatch(uiBusy(true));
      const res = await axios.get(
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/daten/download`,
      );
      return res.data || [];
    } catch (e) {
      // console.error(e)
    } finally {
      dispatch(uiBusy(false));
    }
  };

export const loadDownloadableDatenChunkList =
  (): AppThunkAction => async (dispatch, getState) => {
    try {
      dispatch(uiBusy(true));
      const res = await axios.get(
        `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/export/tables`,
      );
      return res.data || [];
    } catch (e) {
      // console.error(e)
    } finally {
      dispatch(uiBusy(false));
    }
  };

export const deleteProduktempfehlungFavorite =
  (id: number): AppThunkAction =>
  async (dispatch, getState) => {
    await axios.delete(
      `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/favorites`,
      {
        data: {
          id,
        },
      },
    );
  };

export const saveProduktempfehlungFavorite =
  (produktempfehlung_id: number, level: number): AppThunkAction =>
  async (dispatch, getState) => {
    const state = getState();

    const { bandbeschichtung } = state.paramentor;
    const user = state.ui.user as ParamasterUser;

    await axios.post(
      `${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/favorites`,
      {
        produktempfehlung_id,
        level,
        coating: bandbeschichtung > 1,
        user_id: user.id,
        email: user.email ?? user.username,
      },
    );
  };
